import {Instance, flow, types as t} from 'mobx-state-tree'
import User from './User'
import RoleManager from './RoleManager'
import CttStore from './ctt/Store'
import UiStore from './Ui'
import {injectFromEnv} from './injectors'

const Store = injectFromEnv('api')
.named('Store')
.props({
  /**
   * Текущий пользователь
   */
  user: t.optional(User, {}),
  /**
   * Глобальный менеджер ролей
   */
  roleManager: t.optional(RoleManager, {}),
  /**
   * Курьерские расписания
   */
  ctt: t.optional(CttStore, {}),
  /**
   * Глобальный Ui-State
   */
  ui: t.optional(UiStore, {})
})
.actions((self) => {
  const actions = {
    initialize: flow(function * () {
      yield self.user.fetchProfile()
    })
  }

  return actions
})


export default Store
export type StoreType = Instance<typeof Store>
